import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword, guestToken, login } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useForm } from "react-hook-form";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { RotatingLines } from "react-loader-spinner";

export default function ForgotPassword() {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [steps, setSteps] = useState({ Email: '' })

	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	useEffect(() => {
		const guest = localStorage.getItem('guest-token')
		if (!guest) {
			dispatch(guestToken())
		}
		clearErrors('Email')
	}, [])
	const back = () => {
		navigate('/')
	}

	const onFinish = async () => {
		await setIsLoading(true)
		await dispatch(forgotPassword({
			loginData:
			{
				"Records": [
					{
						"Email": steps.Email,
						"PhoneNumber": null
					}
				]
			}
		}))
		await setIsLoading(false)

		await navigate('/login/reset-password')
	};
	const banner = require(`./../../assets/img/banner3 copy.png`)
	const logo = require(`./../../assets/img/digiit.ai.png`)
	return (
		<>
			<form onSubmit={handleSubmit(onFinish)} >
				{(width && width < 724) ? <>
					<div className="w-screen h-screen  px-6 ">
						<div className="flex flex-col items-end justify-around h-full">
							<div className="flex flex-col justify-center w-full h-max px-4 shadow px-3">
								<div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
									Reset Password
									<svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
								</div>
								<div className="w-full my-5">
									<label
										className="block text-sm font-light mb-2" >
										Email Address *
									</label>
									<input
										type="text"
										{...register('Email', {
											required: true,
											pattern:
												/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										})}
										className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Email"
										onChange={(e) => handleSteps(e, 'Email')}
									/>
									{errors.Email && errors.Email.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Email && errors.Email.type === "pattern" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
									)}

								</div>


								<div className="text-center mt-6">
									<button type="submit"
										disabled={isLoading}
										className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
											} flex-row flex items-center justify-center  text-light rounded font-semibold  text-xl p-4 w-full h-12`}

									>Request OTP
										<div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
											<RotatingLines
												visible={true}
												width={'20'}
												strokeColor="#fff"
												strokeWidth="6"
												animationDuration="0.75"
												ariaLabel="rotating-lines-loading"
											/>
										</div>
									</button>
								</div>

							</div>
						</div>
					</div>
				</> :
					<div className="flex min-h-screen w-screen overflow-hidden">
						{/* Left Side - Image */}
						<div className="w-1/2 hidden md:block">
							<img
								src={banner}
								alt="IIMB Building"
								className="w-full h-full object-cover"
							/>
						</div>

						{/* Right Side - Form */}
						<div className="w-full md:w-1/2 flex justify-center items-center bg-white">
							<div className="max-w-md w-full px-6 sm:px-8">
								{/* Logo */}
								<div className="flex justify-center mb-6">
									<img
										src={logo}
										alt="Digiit Logo"
										className="h-10"
									/>
								</div>

								{/* Heading */}
								<h2 className="text-2xl font-semibold text-center mb-6">
									Reset Password
								</h2>

								<div className="w-full my-5">
									<label
										className="block text-sm font-light mb-2" >
										Email Address *
									</label>
									<input
										type="text"
										{...register('Email', {
											required: true,
											pattern:
												/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										})}
										className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
										placeholder="Email"
										onChange={(e) => handleSteps(e, 'Email')}
									/>
									{errors.Email && errors.Email.type === "required" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
									)}
									{errors.Email && errors.Email.type === "pattern" && (
										<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
									)}

								</div>

								{/* Links */}
								<div className="flex flex-col mt-2 text-sm space-y-2">
									<a
										href=""
										onClick={back}
										className="text-blue-600 hover:underline self-start"
									>
										Back to Login
									</a>
								</div>

								{/* Submit */}

								<button
									type="submit"
									disabled={isLoading}
									className={`${isLoading ? 'bg-blue-600 bg-opacity-70' : 'bg-blue-600'
										}  flex-row mt-6 flex items-center justify-center text-white rounded font-semibold text-xl p-4 w-full h-11`}
								>
									Request OTP
									<div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
										<RotatingLines
											visible={true}
											width={'20'}
											strokeColor="#fff"
											strokeWidth="6"
											animationDuration="0.75"
											ariaLabel="rotating-lines-loading"
										/>
									</div>
								</button>





								{/* Terms */}
								<div className="mt-4 text-xs text-center text-gray-500">
									<p>Terms of use - Privacy policy</p>
									<p className="mt-1">
										This site is protected by Digiit Business Services{" "}
										<a href="https://policies.google.com/privacy" className="underline">
											Privacy Policy
										</a>{" "}
										and{" "}
										<a href="https://policies.google.com/terms" className="underline">
											Terms of Service
										</a>{" "}
										apply.
									</p>
								</div>
							</div>
						</div>
					</div>}
			</form >
		</>
	);
}
